export default __webpack_public_path__ + "static/media/dashboard-alerts.02fff157.svg";